import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const IconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(56)};
  height: ${pxToRem(56)};
  border-radius: ${theme.borderRadius.circle};
  background-color: ${theme.swatches.green[500]};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }
`;
